import {
  getVisibleSettingsSections,
  ResolvedSettingsPage,
  SETTINGS_PAGES,
  SettingsPage,
  SettingsVisibilityContext,
} from 'src/features/settings/registry/settingsRegistry';

/** How many matching settings a result lists under its page, as the prototype does. */
export const MAX_SETTING_HITS = 3;

export interface SettingsSearchResult {
  page: ResolvedSettingsPage;
  /** The page's settings whose labels match, at most MAX_SETTING_HITS. */
  hits: string[];
}

/**
 * The pages a query finds, in sidebar order: a page matches on its own label
 * or on any of its settings' labels (case-insensitive substring). Only pages
 * the sidebar would show are searched, so a result is always one the user can
 * open.
 */
export const searchSettingsPages = ({
  query,
  ctx,
  clientTerm,
  pages = SETTINGS_PAGES,
}: {
  query: string;
  ctx: SettingsVisibilityContext;
  clientTerm: string;
  pages?: ReadonlyArray<SettingsPage>;
}): SettingsSearchResult[] => {
  const needle = query.trim().toLowerCase();
  if (!needle) return [];

  return getVisibleSettingsSections(ctx, clientTerm, pages)
    .flatMap((section) => section.pages)
    .flatMap((page) => {
      const hits = (page.settings ?? []).filter((label) =>
        label.toLowerCase().includes(needle),
      );
      if (!page.label.toLowerCase().includes(needle) && hits.length === 0) {
        return [];
      }
      return [{ page, hits: hits.slice(0, MAX_SETTING_HITS) }];
    });
};
